import { useSelector } from "react-redux";

export default function GlobalLoader() {
  const isLoading = useSelector((state) => state.loading.isLoading);

  if (!isLoading) return null;

  return (
    <div className="global-loading-overlay">
      <div className="loader"></div>
    </div>
  );
}
